import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TeamV2NotificationsContainer = () => {
    return (
        <Box sx={{ p: 3 }}>
            <Paper sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom color="primary">
                    🔔 Team Notifications
                </Typography>
                <Typography variant="body1">
                    Team notifications and alerts page - Coming soon
                </Typography>
            </Paper>
        </Box>
    );
};

export default TeamV2NotificationsContainer;
